import { Content } from './types'

const paragraph: Content = {
    type: 'paragraph',
    name: 'Alinea',
}

export default paragraph
